import React from "react";
import { motion } from "framer-motion";
import Form from "../../components/Book";

const Booking = () => (
  <main className="relative min-h-screen overflow-hidden bg-[#0D1A32] px-5 pb-20 pt-32 sm:px-10 lg:flex lg:items-center lg:py-32">
    <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: "url('/images/general/booking.jpg')" }} />
    <div className="absolute inset-0 bg-gradient-to-r from-[#0D1A32]/95 via-[#14274A]/75 to-[#14274A]/45" />
    <div className="absolute inset-0 hero-grain" />
    <div className="absolute -left-32 bottom-[-220px] h-[460px] w-[460px] rounded-full border border-[#E0B973]/15" />
    <div className="absolute -left-20 bottom-[-170px] h-[360px] w-[360px] rounded-full border border-[#E0B973]/15" />

    <div className="relative z-[1] mx-auto grid w-full max-w-7xl items-center gap-14 lg:grid-cols-[.85fr_1.15fr] lg:gap-20">
      <motion.section initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: .9, ease: [0.16, 1, 0.3, 1] }} className="max-w-xl text-white">
        <p className="section-eyebrow !text-[#E0B973]">Your stay begins here</p>
        <h1 className="font-garamond text-6xl font-medium leading-[.88] tracking-[-.03em] sm:text-7xl xl:text-[6.2rem]">Make room<br />for <span className="italic text-[#E0B973]">something</span><br />memorable.</h1>
        <p className="mt-7 max-w-md font-montserrat text-sm font-light leading-7 text-white/70">Choose your dates and let us take care of the rest. Quiet rooms, Bhutanese warmth and an unhurried stay are waiting in Samtse.</p>
        <div className="mt-10 hidden grid-cols-3 gap-6 border-t border-white/15 pt-7 sm:grid">
          <div><strong className="block font-garamond text-2xl font-medium text-[#E0B973]">01</strong><span className="font-montserrat text-[8px] uppercase tracking-[.18em] text-white/50">Choose dates</span></div>
          <div><strong className="block font-garamond text-2xl font-medium text-[#E0B973]">02</strong><span className="font-montserrat text-[8px] uppercase tracking-[.18em] text-white/50">Select room</span></div>
          <div><strong className="block font-garamond text-2xl font-medium text-[#E0B973]">03</strong><span className="font-montserrat text-[8px] uppercase tracking-[.18em] text-white/50">Confirm stay</span></div>
        </div>
      </motion.section>
      <Form />
    </div>
  </main>
);

export default Booking;
